import { EmptyDataMessage } from "@/common/components/EmptyDataMessage";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { maintenanceForwardingsDirectiveEntryKlasses } from "@/features/maintenance/features/workflows/constants/forwardings/maintenanceForwardingsDirectiveEntryKlasses.constant";
import { ForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import { useMaintenanceForwarding } from "@/features/maintenance/features/workflows/hooks/forwardings/useMaintenanceForwarding";
import { useWorkflowShowStore } from "@/features/maintenance/features/workflows/stores/workflowShowStore";
import { MaintenaceWorkflowData } from "@/features/maintenance/features/workflows/types/maintenanceWorkflows.type";
import { useEffect, useMemo } from "react";
import MaintenanceWorkflowForwardingShowLoading from "./MaintenanceWorkflowForwardingShowLoading";
import { MaintenanceForwardingData } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwarding.type";

interface MaintenanceWorkflowForwardingShowProps {
  workflow?: MaintenaceWorkflowData;
}

const MaintenanceWorkflowForwardingShow = ({ workflow }: MaintenanceWorkflowForwardingShowProps) => {
  const { setForwarding } = useWorkflowShowStore();

  const {
    data: forwarding,
    isPending: forwardingIsPending,
    error: forwardingError = {} as any,
    refetch: refetchForwarding,
    dataUpdatedAt: forwardingUpdatedAt,
  } = useMaintenanceForwarding(workflow?.current_forwarding?.id);

  const ForwardingStateComponent = useMemo(() => {
    if (!workflow?.current_forwarding?.directive_entry_type) {
      return false;
    }

    const maintenaceDirectiveEntryData = maintenanceForwardingsDirectiveEntryKlasses[workflow?.current_forwarding?.directive_entry_type];

    if (!maintenaceDirectiveEntryData) {
      return false;
    }

    const directiveEntryStatusData = workflow?.current_forwarding?.status && maintenaceDirectiveEntryData.status[workflow?.current_forwarding?.status];

    if (!directiveEntryStatusData) {
      return false;
    }

    return directiveEntryStatusData.component || false;
  }, [workflow?.current_forwarding?.directive_entry_type, workflow?.current_forwarding?.status]);

  useEffect(() => {
    setForwarding(forwarding as MaintenanceForwardingData | undefined);
  }, [forwardingUpdatedAt]);

  if (forwardingIsPending) {
    return <MaintenanceWorkflowForwardingShowLoading />
  }

  return (
    <ErrorMessageWrapper
      className="flex-1"
      statusCode={forwardingError?.status}
      refetchFunction={refetchForwarding}
    >
      {forwarding && ForwardingStateComponent && (
        <ForwardingTabContext.Provider
          value={{
            forwarding,
            forwardingUpdatedAt,
            directiveEntryKlass: workflow?.current_forwarding?.directive_entry_type,
          }}
        >
          <div className="flex-1 overflow-auto flex flex-col gap-4">
            <ForwardingStateComponent />
          </div>
        </ForwardingTabContext.Provider>
      )}

      {(!forwarding || !ForwardingStateComponent) && (
        <EmptyDataMessage className="flex-1" />
      )}
    </ErrorMessageWrapper>
  );
}

export default MaintenanceWorkflowForwardingShow;
